import { Component, computed, output, inject } from "@angular/core";
import { HeaderLocationService } from "src/app/shared/services/header-location.service";
import { MatIcon } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";
import { TinyObjectListComponent } from "../tiny-object-list/tiny-object-list.component";
import { TranslocoPipe } from "@jsverse/transloco";
import { TinyPlotObjectListComponent } from "../tiny-plot-object-list/tiny-plot-object-list.component";
import { TinyObject } from "src/app/shared/contract/Address/tiny-object";
import { BuildingInfoDatasource } from "@enums/building-info-datasource.enum";
import { TinyPlot } from "src/app/shared/contract/Address/tiny-plot";
import { BasemapService } from "src/app/modules/basemap/basemap.service";
import { Address } from "src/app/shared/contract/Address/Address";
import { getObjectCoordinateFromCoordinate } from "src/app/shared/helpers/coordinate-helper";
@Component({
  selector: "app-address-lookup",
  templateUrl: "./address-lookup.component.html",
  styleUrl: "./address-lookup.component.scss",
  imports: [MatIcon, MatTooltip, TinyObjectListComponent, TinyPlotObjectListComponent, TranslocoPipe]
})
export class AddressLookupComponent {
  readonly headerLocationService = inject(HeaderLocationService);
  readonly basemapService = inject(BasemapService);

  lookupResponse = this.headerLocationService.lookupResponse;

  isResidentialAllowed = computed(() => this.lookupResponse()?.ModuleRights.includes("ResidentialAvm"));
  residentialSourceTranslationKey = computed(() => this.getDatasourceTranslationKey(this.lookupResponse()?.Datasources.Residential));

  isCommercialAllowed = computed(() => this.lookupResponse()?.ModuleRights.includes("CommercialAVM"));
  commercialSourceTranslationKey = computed(() => this.getDatasourceTranslationKey(this.lookupResponse()?.Datasources.Commercial));

  isRvmAllowed = computed(() => this.lookupResponse().ModuleRights.includes("Rvm"));

  isPlotAllowed = computed(() => this.lookupResponse()?.ModuleRights.includes("BPS") && this.lookupResponse()?.PlotObjects?.length > 0);
  plotSourceTranslationKey = computed(() => this.getDatasourceTranslationKey(this.lookupResponse()?.Datasources.Plot));

  createNewObjectClicked = output<"residential" | "commercial" | "rvm">();

  selectObject(object: TinyObject, type: "residential" | "commercial" | "rvm") {
    if (!object) {
      return;
    }

    const address = this.headerLocationService.selectedSuggestion()?.Address;
    if (!address) return;

    this.headerLocationService.navigateToObject(address, object, type);
  }

  selectPlotObject(tinyPlot: TinyPlot | null) {
    if (!tinyPlot) {
      return;
    }

    let address = this.headerLocationService.selectedSuggestion()?.Address;
    if (!address) {
      address = new Address();
      address.Coordinate = getObjectCoordinateFromCoordinate(this.basemapService.currentSelectedMarkerCoordinate);
      address.Coordinate.Country = this.basemapService.country.value;
    }

    this.headerLocationService.navigateToPlot(address.Coordinate, tinyPlot);
  }

  getDatasourceTranslationKey(datasource: BuildingInfoDatasource): string {
    switch (datasource) {
      case BuildingInfoDatasource.OrderingService:
        return "Module.Address.DataSource.OrderingService";
      case BuildingInfoDatasource.GeoService:
        return "Module.Address.DataSource.GeoService";
      case BuildingInfoDatasource.Oodit:
        return "Module.Address.DataSource.Oodit";
      default:
        return "Module.Address.DataSource.None";
    }
  }
}
